// Icon registry - Automatically discovers all SVG files in src/assets/svg-icons/
// To add a new icon:
// 1. Place the SVG file in src/assets/svg-icons/ with a descriptive filename
// 2. The icon will be automatically available with the filename (without .svg) as the name
// 3. No manual imports or registry updates needed!

// Auto-discover all SVG files using Vite's glob import
const svgModules = import.meta.glob('/src/assets/svg-icons/*.svg', { 
  query: '?raw', 
  import: 'default',
  eager: true 
})

// Generate icon registry from discovered SVG files
export const iconRegistry: Record<string, string> = Object.fromEntries(
  Object.entries(svgModules).map(([path, content]) => {
    // Extract filename without extension as icon name
    const name = path.match(/\/([^/]+)\.svg$/)?.[1] || ''
    return [name, content as string]
  })
)

// Type-safe icon names
export type IconName = keyof typeof iconRegistry

// Helper function to get available icon names
export const getAvailableIcons = (): IconName[] => {
  return Object.keys(iconRegistry) as IconName[]
}

// Helper function to check if an icon exists
export const hasIcon = (name: string): name is IconName => {
  return name in iconRegistry
}